import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios';
import EvnVar from '../../EnvVar'
// import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
// import AuthGaurd from '../../AuthGaurd'

const baseURL = EvnVar()
// console.log(baseURL);

function LoginForm() {
    const { setIsAuthenticated } = useAuth(); // Get setIsAuthenticated from context
    setIsAuthenticated(false)
    const [getOTP, SetGetOTP] = useState(false)
    const [loader, setLoader] = useState(false)

    const [formData, SetFormData] = useState({
        category: 'true',
        membership: '',
        registration: '',
        otp: ''
    })

    const [rnumberError, setRnumberError] = useState(null)
    // const navigate = useNavigate();

    const handleChange = (e) => {
        const { id, value } = e.target
        const updatedFormData = {
            ...formData, [id]: value
        }

        if (id === 'membership') {
            // updatedFormData.membership = value.replace(/\D/g, '').slice(0, 10);
            updatedFormData.membership = value
        }

        if (id === 'registration') {
            // updatedFormData.registration = value.replace(/[^0-9a-zA-Z]/g, '').slice(0, 15);
            updatedFormData.registration = value

            // const sixNumericDigit = value.replace(/[^0-9]/gi, '').slice(0, 6);
            // const sixAlphaDigit = value.replace(/[^a-z]/gi, '').slice(0, 4);
            // updatedFormData.registration = sixNumericDigit + sixAlphaDigit
        }
        SetFormData(updatedFormData)
    }


    const mNumberSubmit = (e) => {
        e.preventDefault();
        setLoader(true)
        // console.log('Form Data Submitted:', formData);
        // You can send formData to your server here
        let rnumber = formData.category === "true" || formData.category === "branch" ? formData.membership : formData.registration
        let userData = JSON.stringify({
            "rnumber": rnumber
        });

        // console.log('Sending to api:', JSON.parse(userData));

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${baseURL}/auth/otp`,
            headers: {
                'content-type': 'application/json'
            },
            data: userData,
        }

        axios.request(config)
            .then((response) => {
                // console.log(JSON.stringify(response.data));
                SetGetOTP(true)
                setRnumberError(null)
                setLoader(false)

                // setIsAuthenticated(false); // Set isAuthenticated to true on successful login
            })
            .catch((error) => {
                console.log(error);
                setRnumberError(error.response.data.error)
                setLoader(false)
            })
    }

    async function otpSubmit(e) {
        e.preventDefault();
        setLoader(true)
        // console.log('Form Data Submitted:', formData);
        let rnumber = formData.category === "true" || formData.category === "branch" ? formData.membership : formData.registration
        let userOTP = JSON.stringify({
            "rnumber": rnumber,
            "otp": formData.otp
        });

        // console.log("sending to api userOTP ===>", JSON.parse(userOTP));

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${baseURL}/auth/login`,
            headers: {
                'content-type': 'application/json'
            },
            data: userOTP,
            withCredentials: true
        }

        axios.request(config)
            .then((response) => {
                // console.log(JSON.stringify(response.data));
                let result = JSON.stringify(response.data);
                let jsonResult = JSON.parse(result)
                // console.log("jsonResult", result);
                setCookie('jwt', jsonResult.token, 7); // Set a cookie for 7 days
                // jsonResult.role == "ambassador" ? navigate('/ambassador/dash') : navigate('/ambassador/admin-dash')
                setIsAuthenticated(true); // Set isAuthenticated to true on successful login
                // AuthGaurd()
                setLoader(false)
            })
            .catch((error) => {
                console.log(error);
                setRnumberError(error.response.data.error)
                setLoader(false)
            })


        function setCookie(name, value, days) {
            let expires = "";
            if (days) {
                const date = new Date();
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + (value || "") + expires + "; path=/";
        }

    }

    return (
        <div className='row'>
            <div className='col-lg-6 m-auto'>
                {!getOTP ? <form className="row g-3"
                    onSubmit={mNumberSubmit}
                >
                    <div className="col-12">
                        <label htmlFor="category" className="form-label">Category (Chartered Accountant/Student)</label>
                        <select className="form-select" aria-label="Default select example" id="category" value={formData.category} required onChange={handleChange}>
                            <option value="true">Chartered Accountant</option>
                            <option value="false">Student</option>
                            <option value="branch">Branch</option>
                        </select>
                    </div>
                    {formData.category != "false" ?
                        <div className="col-12">
                            <label htmlFor="membership" className="form-label">ICAI Membership Number (for CAs)</label>
                            <input type="text" className="form-control" id="membership" value={formData.membership} required onChange={handleChange} placeholder="Membership Number" />
                            {rnumberError && <p className='text-danger mb-0'>{rnumberError}.</p>}
                        </div> :
                        <div className="col-12">
                            <label htmlFor="registration" className="form-label">Student Registration Number (for students)</label>
                            <input type="text" className="form-control" id="registration" value={formData.registration} required onChange={handleChange} placeholder="Registration Number" />
                            {rnumberError && <p className='text-danger mb-0'>{rnumberError}.</p>}
                        </div>
                    }
                    <div className="col-12">
                        {loader && loader ? <button type="submit" className="btn btn-primary" disabled>
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Login
                        </button> : <button type="submit" className="btn btn-primary">Login</button>}
                        <p className='mt-3'><Link to="/ambassador/registration">Don't have account, click here for registration</Link></p>
                    </div>
                </form> :
                    <form className="row g-3"
                        onSubmit={otpSubmit}
                    >
                        <div className="col-12">
                            <label htmlFor="otp" className="form-label">Enter OTP</label>
                            <input type="text" className="form-control" id="otp" required placeholder="OTP" onChange={handleChange} />
                            {rnumberError && <p className='text-danger mb-0'>{rnumberError}.</p>}
                        </div>
                        <div className="col-12">
                            {loader && loader ? <button type="submit" className="btn btn-primary" disabled>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Submit</button> : <button type="submit" className="btn btn-primary">Submit</button>}
                        </div>
                    </form>
                }
            </div>
        </div >
    )
}

export default LoginForm
